import { ApolloError } from '@apollo/client'
import { useCallback } from 'react'
import { useToast } from './useToast'

export const useApolloErrorToast = () => {
  const toast = useToast()
  return useCallback(
    (e: ApolloError) => {
      let title = '問題が発生しました。時間を置いて再度お試しください。'

      if (e.graphQLErrors && e.graphQLErrors.length > 0) {
        const firstError = e.graphQLErrors[0]
        if (firstError.extensions?.['detailed_code']) {
          title = firstError.message
        }
      }

      toast({
        title,
        status: 'error',
      })
    },
    [toast],
  )
}
